import React, { Component } from 'react'
import { Toggle } from '@checkmarx/cx-ui';

export default class ActivateUser extends Component {

    render() {

        const { onChange, disabled, checked, title, userId, currentUserId } = this.props;
        const shouldDisable = (userId == currentUserId) ? true : disabled;

        return (
            <div>
                <label>
                    <Toggle
                        icons={false}
                        onChange={onChange}
                        disabled={shouldDisable}
                        checked={checked}
                        text={title}
                    />
                </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/addEditUser/activateUser.jsx